import { render } from "./header-user.vue?vue&type=template&id=6b4e4f8b&scoped=true"
import script from "./header-user.vue?vue&type=script&lang=js"
export * from "./header-user.vue?vue&type=script&lang=js"

import "./header-user.vue?vue&type=style&index=0&id=6b4e4f8b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4e4f8b"]])

export default __exports__